//DO NOT TOUCH WITHOUT PROPER PERMISSION

require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/kiosks_queues_options.template.htm');
require('dhtmlxMessage');
var HandlebarsHelpers = require('../../libs/handlebars/handlebars-helpers.ts');
var QueuesModel = require('../models/queues.model.ts');
var QueuesCollection = require('../models/queues.paginated.collection.ts');
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: '#kQueuesOptions',
    tagName: 'span',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	userPrivilege: null,
	id: null,
	editable: false,
    initiallyDeselected: [],
    initiallySelected: [],
	queuesToBeAdded: [],
	queuesToBeRemoved: [],
	queueType: null,
	allQueues: [],
	totalCalls: 0,
	callback: null,
	initialize: function (options) {
		var self = this;
		this.userPrivilege = options.userPrivilege;
		this.id = options.id;
		this.editable = options.editable;
		this.initiallySelected = options.queues || options.queues != undefined ? options.queues : [];
		//this.clearData();

		this.queueType = options.queueType;

		this.initializeQueuesCollection();

	},
	initializeQueuesCollection: function()
	{
		this.queuesCollection = new QueuesCollection();
		this.queuesCollection.url = '/rest/api/queues/' + this.queueType;
		this.queuesCollection.on('sync', this.queuesSuccess, this);
		this.queuesCollection.on('error', this.queuesError, this);
		this.queuesCollection.state.pageSize = 999;
		this.queuesCollection.getFirstPage();
	},
	isQueueIn: function(item, arrayData) {
	    return arrayData.filter(elem =>
	        item.id === elem.id
	    )[0];
	},
	queuesSuccess: function()
	{
		var self = this;

        this.initiallyDeselected = this.queuesCollection.models
			.filter(item => !self.isQueueIn(item, self.initiallySelected))
			.map(item => ({ id: item.attributes.id, name: item.attributes.name }));

		this.render();

		if (this.queuesCollection.length == 0){
		    $('#noqueues').show();
		    this.areQueues = false;
		}
		else {
		    $('#noqueues').hide();
		    this.areQueues = true;
		}
		this.showQueueData();
	},
	showQueueData: function() {
        var self = this;
        $('#myhelpingtext').hide();
        if (this.areQueues == true) {
            $("#multiselect").chosen({
                disable_search_threshold: 10,
                no_results_text: i18n.t("kiosks.nothing_found"),
                width: "100%"
            }).change(function(event){

            });
        }

	},
	queuesError: function()
	{
		
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();
		this.$el.html(this.template({ select: this.initiallySelected, unselect: this.initiallyDeselected}));

        if (this.editable)
            $('#myhelpingtext').hide();
	},
	events: {
	},
	isNewKiosk: function()
	{
		return this.id ? false : true;
	},
	clearView: function()
	{
		this.clearData();
		this.queuesCollection = null;
		this.$el.removeClass("has-error");
		this.$el.html("");
	},
});

module.exports = TheView;